import { LinkButton } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../pages";
import { ReferralText } from "./ReferralText";
import { TrustSection } from "./TrustSection";
import type { ReferralProps } from "./types";

export const Referral = ({ ref, ...props }: WithMetadata<ReferralProps>) => {
  const {
    className,
    firstName,
    showTrustSection,
    referenceNumber,
    phoneNumbers,
    sbDirect,
    checkoutUrl,
    backUrl,
    children,
    componentName,
    ...otherProps
  } = props;

  const classes = classNames("mobius", "mobius-referral", className);
  const { variant } = otherProps;

  const showCheckoutButtons =
    variant === "with-coverage-summary" && checkoutUrl;

  const textProps = {
    firstName,
    referenceNumber,
    phoneNumbers,
    sbDirect,
  };

  return (
    <div
      ref={ref}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
      data-testid="referral"
    >
      <ReferralText {...textProps}>
        {showCheckoutButtons && (
          <div className="mobius-checkout-buttons">
            <LinkButton
              href={backUrl ?? "#"}
              variant="secondary"
              data-testid="back-button"
            >
              Back
            </LinkButton>
            <LinkButton
              href={checkoutUrl}
              variant="primary"
              data-testid="checkout-button"
            >
              Checkout
            </LinkButton>
          </div>
        )}
      </ReferralText>
      {showTrustSection && <TrustSection />}
      {children}
    </div>
  );
};

Referral.displayName = "Referral";
